"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleTextField = void 0;
const joi_1 = __importDefault(require("joi"));
const text_base_field_1 = require("./text_base_field");
const field_types_1 = require("../../types/field_types");
const model_1 = require("../../model");
class SingleTextField extends text_base_field_1.TextBaseField {
    constructor(field, state) {
        super(field, state);
        this.field = field;
        this.state = state;
    }
    static defaultProperty() {
        return {};
    }
    get apiMetaProperty() {
        return {
            defaultValue: this.field.property.defaultValue,
        };
    }
    validateProperty() {
        return SingleTextField.propertySchema.validate(this.field.property);
    }
    defaultValue() {
        const defaultValue = this.field.property.defaultValue;
        if (!defaultValue || !defaultValue.trim().length) {
            return null;
        }
        return [{ type: field_types_1.SegmentType.Text, text: defaultValue }];
    }
    static createDefault(fieldMap) {
        return {
            id: model_1.DatasheetActions.getNewFieldId(fieldMap),
            name: model_1.DatasheetActions.getDefaultFieldName(fieldMap),
            type: field_types_1.FieldType.SingleText,
            property: this.defaultProperty(),
        };
    }
    /**
     * @description Convert multi-line text to single-line text, you need to replace the newline character with a space, other logic remains unchanged
     * @param {IStandardValue} stdField
     * @returns {(ISegment[] | null)}
     * @memberof SingleTextField
     */
    stdValueToCellValue(stdField) {
        const { data, sourceType } = stdField;
        if (data.length === 0) {
            return null;
        }
        if (sourceType === field_types_1.FieldType.Text) {
            return data.map(d => {
                return {
                    type: d.type || field_types_1.SegmentType.Text,
                    text: d.text.replace(/\n/g, ' '),
                };
            });
        }
        return super.stdValueToCellValue(stdField);
    }
    get openFieldProperty() {
        const { defaultValue } = this.field.property;
        return { defaultValue };
    }
    validateUpdateOpenProperty(property) {
        return SingleTextField.propertySchema.validate(property);
    }
}
exports.SingleTextField = SingleTextField;
SingleTextField.propertySchema = joi_1.default.object({
    defaultValue: joi_1.default.string().allow('')
});
//# sourceMappingURL=single_text_field.js.map